import { loadable as baseLoadable } from './Loadable/index';

export const loadable = (createImport, { key, timeout }) =>
  baseLoadable(createImport, {
    resolveComponent: key ? (mod) => mod[key] : (mod) => mod.default,
    timeout,
  });
